/*
 *   File : send-mail.js
 *   Author : https://zappit.com
 *   Description : Send mail  modal
 *   Integrations : NA
 *   Version : 1.0.0
*/

// custom packages

// custom components
import { PrimaryButton } from '../Buttons';

// custom styles
import style from "../../Style/Components/modal.module.scss";


const SuccessConfirmation = (props) => {


    return (
        <div className="modal fade "
            id="success-confirmation-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="SendMailModalLabel"
            aria-hidden="true">

            <div className={` modal-dialog modal-dialog-centered ${props.type === 2 ? 'modal-lg' : style.e_send_mail_modal_width}  border-radius-28`}>
                <span id='open-account-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className={` modal-content  border-radius-28  border-0`}>

                    <div className='modal-body pt-4 pb-0 padding-32px-lr text-center'>
                        <img src={require("../../Assets/Images/check-circle.gif")}
                            alt="Success"
                            width={120} />
                        <h6 className='mb-0 color-white e-primary-font py-2 e-font-weight-500 e-font-16  line-height-100-percent'>
                            Onboarding success
                        </h6>
                        <p className='mb-0 color-white e-primary-font e-font-weight-500 e-font-16  line-height-100-percent'>
                            Your information has been successfully submitted. Onboarding is now complete.
                        </p>
                    </div>
                    <div className='py-4 padding-32px-lr padding-32px-bottom px-3'>
                        <div className='row justify-content-center'>

                            <div className='col-6'>
                                <PrimaryButton label='Home'
                                    cancel="modal"
                                    // loader={props.loader}
                                    handleClick={() => {
                                        window.location.href = "/";
                                        sessionStorage.clear();
                                    }} />
                            </div>
                        </div>
                    </div>



                </div>
            </div>
        </div >
    )
}

export default SuccessConfirmation;

SuccessConfirmation.defaultProps = {
    handleClose: () => { },
    type: 1,
}